<template>
  <StepLayout
    :on-save="onSave"
    :is-busy-on-save="isBusyOnSave"
    :on-next="onNext"
    :is-busy-on-next="isBusyOnNext"
    :on-back="onBack"
    :is-disabled="isDisabled"
    helpscout-article="65686537b1d9b5438dbdb484"
    step-navigation-button-data-ec="bulk_send_sharing_page"
  >
    <template v-slot:title>
      {{ $t('bulkSend.steps.sharing.title', { name }) }}
    </template>
    <SharingView
      @itemAdded="itemAdded"
      @itemRemoved="itemRemoved"
      @permissionChanged="permissionChanged"
      :permittedActorsListTitle="$t('sharing.currentSharing', { resource: 'bulk send' })"
      v-model="sharing"
    />
  </StepLayout>
</template>

<script>
import { computed, ref } from 'vue';
import { useBulkSendStepsNavigation } from '@/composables/bulkSend/steps';
import { logAmplitudeEvent } from '@/utils/analytics';

import StepLayout from '@/components/ui/bulkSend/StepLayout.vue';
import SharingView from '@/components/Sharing.vue';
import { useGetters } from 'vuex-composition-helpers/dist';

export default {
  name: 'SharingPage',
  components: {
    StepLayout,
    SharingView,
  },
  setup() {
    // get bulk send data
    // @ts-ignore - useGetters has bad types
    const { bulkSend } = useGetters({ bulkSend: 'bulkSend/bulkSend' });
    const name = computed(() => bulkSend.value.name);

    // initialise local state
    const sharing = ref(bulkSend.value.sharing);

    const updateValue = computed(() => {
      // eslint-disable-next-line camelcase
      const { everyone_permission_id, groups, users } = sharing.value;
      return { everyone_permission_id, groups, users };
    });

    const {
      onNext,
      isBusyOnNext,
      onSave,
      isBusyOnSave,
      onBack,
      isDisabled,
    } = useBulkSendStepsNavigation(
      'bulkSend/updateSharing',
      updateValue,
    );

    return {
      name,
      sharing,
      onNext,
      isBusyOnNext,
      onSave,
      isBusyOnSave,
      onBack,
      isDisabled,
    };
  },
  methods: {
    itemAdded(item) {
      logAmplitudeEvent(
        'bulk_send_sharing_page--added_actor_to_template_sharing',
        { type: item.type },
      );
    },
    itemRemoved(item) {
      logAmplitudeEvent(
        'bulk_send_sharing_page--removed_actor_from_template_sharing',
        { type: item.type },
      );
    },
    permissionChanged(value) {
      logAmplitudeEvent('bulk_send_sharing_page--permission_changed', {
        type: value.slug,
      });
    },
  },
};
</script>
